import { License_RegistrationType } from '@/graphql/codegen/generated/graphql';

export const NULL_LICENSE_OPTION = { label: '---------' as const, value: null };

export const initiatorTypeslist: { label: string; value: string | null; tooltip?: boolean }[] = [
  NULL_LICENSE_OPTION,
  { label: 'Fixed initiator' as const, value: License_RegistrationType.Fixed, tooltip: true },
  { label: 'Floating initiator' as const, value: License_RegistrationType.Floating },
  { label: 'Fixed CI initiator' as const, value: License_RegistrationType.Fixed, tooltip: true },
  { label: 'Floating CI initiator' as const, value: License_RegistrationType.Floating },
  { label: 'None' as const, value: License_RegistrationType.None },
];
export const helperTypeslist = [
  NULL_LICENSE_OPTION,
  { label: 'Fixed helper' as const, value: License_RegistrationType.Fixed },
  { label: 'Floating helper' as const, value: License_RegistrationType.Floating },
  { label: 'None' as const, value: License_RegistrationType.None },
];

export const initiatorLicenseTypeMap: Record<License_RegistrationType, typeof initiatorTypeslist[number]> = {
  [License_RegistrationType.Fixed]: { label: 'Fixed initiator' as const, value: License_RegistrationType.Fixed },
  [License_RegistrationType.Floating]: { label: 'Floating initiator' as const, value: License_RegistrationType.Floating },
  [License_RegistrationType.None]: { label: 'None' as const, value: License_RegistrationType.None },
};

export const CIInitiatorLicenseTypeMap: Record<License_RegistrationType, typeof initiatorTypeslist[number]> = {
  [License_RegistrationType.Fixed]: { label: 'Fixed CI initiator' as const, value: License_RegistrationType.Fixed },
  [License_RegistrationType.Floating]: { label: 'Floating CI initiator' as const, value: License_RegistrationType.Floating },
  [License_RegistrationType.None]: { label: 'None' as const, value: License_RegistrationType.None },
};

export const helperLicenseTypeMap: Record<License_RegistrationType, typeof helperTypeslist[number]> = {
  [License_RegistrationType.Fixed]: { label: 'Fixed helper' as const, value: License_RegistrationType.Fixed },
  [License_RegistrationType.Floating]: { label: 'Floating helper' as const, value: License_RegistrationType.Floating },
  [License_RegistrationType.None]: { label: 'None' as const, value: License_RegistrationType.None },
};
